import { create } from 'zustand';
import type { VideoFilterId, VideoFilterSettings } from './ports';
import { getVideoFilterService } from './container';

interface VideoFilterState {
  settings: VideoFilterSettings;
  setFilter: (filterId: VideoFilterId) => void;
  setIntensity: (intensity: number) => void;
  processStream: (stream: MediaStream) => Promise<MediaStream>;
  stopProcessing: () => void;
}

export const VIDEO_FILTER_OPTIONS: { value: VideoFilterId; label: string }[] = [
  { value: 'none', label: 'No filter' },
  { value: 'background-blur', label: 'Background blur' },
  { value: 'soft-mask', label: 'Soft mask' },
  { value: 'color-correct', label: 'Color correct' },
];

export const useVideoFilterStore = create<VideoFilterState>((set, get) => ({
  settings: {
    filterId: 'none',
    intensity: 0.65,
  },

  setFilter: (filterId) => {
    set((state) => {
      const settings = { ...state.settings, filterId };
      getVideoFilterService().updateSettings(settings);
      return { settings };
    });
  },

  setIntensity: (intensity) => {
    set((state) => {
      const settings = {
        ...state.settings,
        intensity: Math.max(0, Math.min(1, intensity)),
      };
      getVideoFilterService().updateSettings(settings);
      return { settings };
    });
  },

  processStream: async (stream) => {
    const { settings } = get();
    return getVideoFilterService().process(stream, settings);
  },

  stopProcessing: () => {
    getVideoFilterService().stop();
  },
}));
